export default __webpack_public_path__ + "static/media/reverse.0977aab3.jpg";